import { Type, type Static } from "@sinclair/typebox";

export const JsonValueSchema = Type.Recursive(
  (This) =>
    Type.Union([
      Type.String(),
      Type.Number(),
      Type.Boolean(),
      Type.Null(),
      Type.Array(This, { maxItems: 256 }),
      Type.Record(Type.String({ maxLength: 128 }), This, { maxProperties: 256 })
    ]),
  { $id: "JsonValue" }
);

export const JsonObjectSchema = Type.Record(Type.String({ maxLength: 128 }), JsonValueSchema, {
  maxProperties: 256
});

export type JsonWireValue = Static<typeof JsonValueSchema>;
export type JsonWireObject = Static<typeof JsonObjectSchema>;
